<template>
  <div id="app">
    <div
      v-if="mobile === false"
      id="nav"
      @mouseenter="navigationHovered = true"
      @mouseleave="navigationHovered = false"
    >
      <router-link id="nav-work" to="/">WORK</router-link>
      <router-link id="nav-about" to="/about">ABOUT</router-link>
      <div id="nav-logo">davidgabathuler</div>
    </div>
    <div v-if="mobile" id="mobile-nav">
      <div class="mobile-nav__logo" @click="mobileHome">davidgabathuler</div>
      <div class="mobile-nav__open" @click="openMobileMenu">
        <img ref="mobileArrow" src="mobilearrow.svg" alt="" />
      </div>
      <div ref="mobileMenu" class="mobile-nav__content">
        <div class="mobile-nav__content-links">
          <router-link
            class="mobile-nav__content-links-link"
            @click.native="closeMobileMenu"
            to="/"
            >WORK</router-link
          >
          <router-link
            class="mobile-nav__content-links-link"
            @click.native="closeMobileMenu"
            to="/about"
            >ABOUT</router-link
          >
        </div>
      </div>
    </div>
    <router-view
      :key="$route.fullPath"
      :navigationHovered="navigationHovered"
    />
  </div>
</template>

<script>
/*eslint-disable */
import { gsap } from 'gsap';
export default {
  data: function() {
    return {
      mobile: '',
      menuOpen: false,
      isOpen: false,
      tl: '',
      navigationHovered: false,
    };
  },
  created() {
    window.backbuttonPressed = false;
    this.mobile = window.isMobile;
    if (window.performance) {
    }
    if (performance.navigation.type == 1) {
      this.$router.push({ name: 'Home' }).catch((err) => {});
    } else {
    }
  },
  mounted() {
    this.tl = gsap.timeline();
  },
  methods: {
    openMobileMenu() {
      // this.menuOpen = true;

      if (this.isOpen === false) {
        this.tl.to(this.$refs.mobileMenu, {
          y: 200,
        });
        this.tl.to(
          this.$refs.mobileArrow,
          {
            rotation: 180,
          },
          '-=.3'
        );
        this.isOpen = true;
      } else {
        this.tl.to(this.$refs.mobileMenu, {
          y: 0,
        });
        this.tl.to(
          this.$refs.mobileArrow,
          {
            rotation: 0,
          },
          '-=.3'
        );
        this.isOpen = false;
      }
    },
    closeMobileMenu() {
      this.tl.to(this.$refs.mobileMenu, {
        y: 0,
      });
      this.tl.to(
        this.$refs.mobileArrow,
        {
          rotation: 0,
        },
        '-=.3'
      );
      this.isOpen = false;
    },
    mobileHome() {
      this.$router.push({ name: 'Home' }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
@import './assets/scss/app.scss';
</style>
